module.exports = __webpack_public_path__ + "static/media/documents.ba1ac9ff.svg";